<template>
    <div class="ui-card">
        
        <h2 v-if="title" class="title"><span class="line"></span>{{title}}
            <div :style="`float:${isRight?'right':'inherit'};display:${!isRight?'inline-block':'block'}`">
                <slot name="extend"></slot>
            </div>
        </h2>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UICard",
    props: {
        isRight: { type: Boolean, default: true },
        title: { type: String, default: "" },
    },
};
</script>

<style lang="less" scoped>
.ui-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    .title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .line{
        width: 4px;
        height: 16px;
        background: #3572e2;
        margin-right: 12px;
        display: inline-block;
    }
    h2 {
        margin-bottom: 20px;
    }
}
</style>